<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Register</v-toolbar-title>
          </v-toolbar>
          <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field v-model="firstname" label="First Name"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="lastname" label="Last Name"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="password" :rules="passwordRule" label="Password" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select v-model="region" :rules="regionRule" :items="regions" label="Knowledge Region" required></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="normal">Create Account</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      region: "",
      regions: ["America", "Australia", "United Kingdom"],
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      emailRules: [
        v => !!v || "Please enter your email address",
        v =>
          /.+@.+\..+/.test(v) ||
          "This doesn't appear to be a valid email address"
      ],
      passwordRule: [
        v => v.length >= 6 || "Password must be at least 6 characters"
      ],
      regionRule: [
        v => !!v || "Select the most accurate locale so we can provide you with more relevant questions"
      ]
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.register();
      }
    },
    register() {
      this.$store
        .dispatch("register", {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: this.password,
          region: this.region
        })
        .then(response => {
          console.log(response);
          this.$router.push({ name: "login" });
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("logging error from login");
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.row {
  margin-left: 0px;
}
</style>